import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { GET_USER_DETAILS_ENDPOINT } from "../globals/endpoints";
import { saveAuth } from "../globals/authentication";

export default function DemoLogin() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [user, setUser] = useState(null);

  const getUserDetails = async () => {
    const response = await axios.get(GET_USER_DETAILS_ENDPOINT, {
      headers: {
        Authorization: "Token " + token,
      },
    });
    console.log(response.data);
    saveAuth(response.data);
    setUser(response.data);
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  if (user) {
    window.location.href = "/";
  }

  return (
    <div>
      <h1>Logging in...</h1>
    </div>
  );
}
